import * as store from '@attain-apps/fe/web/main/lib/store'
import { TypeChecker } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * Ensures the currently selected report has its content loaded.
 */
export const loadCurrentReportContentOnChange = store.effects.create(
  (_feature: Plugin['feature'], plugin: Plugin) =>
    plugin.collection.plugins.currentEntityPlugin.feature.selectors
      .getId()
      .asObservable.pipe(
        rxjs.distinctUntilChanged(),
        rxjs.filter(TypeChecker.isNotNullish.raw),
        rxjs.switchMap(id =>
          rxjs
            .combineLatest({
              isLoading:
                plugin.collection.plugins.dataOperationPlugin.feature.selectors.isLoading(
                  id,
                ).asObservable,
              report:
                plugin.collection.plugins.cachePlugin.feature.selectors.getCachedEntity(
                  id,
                ).asObservable,
            })
            .pipe(
              rxjs.take(1),
              rxjs.map(({ isLoading, report }) => {
                if (isLoading || report?.content) {
                  return store.effects.SKIP
                }

                return plugin.collection.plugins.dataOperationPlugin.feature.actions.get
                  .from('loadCurrentReportContentOnChange (effect)')
                  .create({ id })
              }),
            ),
        ),
      ),
)
